import { render, staticRenderFns } from "./MerchCard.vue?vue&type=template&id=1c097b48&scoped=true"
import script from "./MerchCard.vue?vue&type=script&lang=js"
export * from "./MerchCard.vue?vue&type=script&lang=js"
import style0 from "./MerchCard.vue?vue&type=style&index=0&id=1c097b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c097b48",
  null
  
)

export default component.exports